import type { UnitSystem, ZoneCalcMethod } from '@trainme/db/client';

// Duplicated types from @trainme/db to avoid leaking server-side dependencies to the client
export type Activity = {
  id: number;
  name: string | null;
  distance: number | null;
  movingTime: number | null;
  elapsedTime: number | null;
  sportType: string | null;
  activityType?: string | null;
  startDate: string | null;
  userId: string;
  mapField: any;
  timezone: string | null;
  averageHeartrate: number | null;
  maxHeartrate: number | null;
  calories: number | null;
  source: string | null;
  averageCadence: number | null;
  averagePace: number | null;
  averageSpeed: number | null;
  averageTemp: number | null;
  averageWatts: number | null;
  deviceName: string | null;
  deviceWatts: boolean | null;
  description: string | null;
  endLatlng: any;
  hasHeartrate: boolean | null;
  locationCity: string | null;
  locationCountry: string | null;
  locationState: string | null;
  manual: boolean | null;
  maxSpeed: number | null;
  maxWatts: number | null;
  pushes: number | null;
  resourceState: number | null;
  startDateLocal: string | null;
  startLatlng: any;
  trainer: boolean | null;
  totalElevationGain: number | null;
  totalElevationLoss: number | null;
  utcOffset: number | null;
  weightedAverageWatts: number | null;
  achievementCount: number | null;
  athleteCount: number | null;
  activityId: number | null;
  perceivedExertion: number | null;
  sufferScore: number | null;
  // ... add other fields if needed by the mobile app
};

export type Workout = {
  id: string;
  name: string | null;
  description: string | null;
  steps: any;
  distance: number | null;
  duration: number | null;
  date: Date;
  sportType: string;
  userId: string;
  status: WorkoutStatus;
  createdSource: any;
  isUserEdited: boolean;
  feeling: number | null;
  rpe: number | null;
  notes: string | null;
  createdAt: Date;
  updatedAt: Date;
  garminWorkoutId: number | null;
  garminScheduleId: number | null;
  planInstanceId: string | null;
  weekIndex: number | null;
  workoutKey: string | null;
  // ... add other fields if needed
};

export enum WorkoutStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  SKIPPED = 'SKIPPED',
}

export type TrainingZone = {
  zone: number;
  minValue: number;
  maxValue: number;
  userId?: string;
  type?: string;
};

export type SportsSpeeds = Record<string, number | Record<string, number>>;

export type Analysis = {
  id: string;
  coachSay: string | null;
  trainmeScore: number | null;
};

export type StravaLap = {
  id: number;
  name?: string | null;
  movingTime?: number;
  moving_time?: number;
  elapsedTime?: number;
  elapsed_time?: number;
  lapIndex?: number;
  lap_index?: number;
  averageHeartrate?: number;
  average_heartrate?: number;
  userId?: string;
  // Additional optional fields can be added as needed
};

export type User = {
  id: string;
  email: string;
};

export type ForumUser = {
  id: string;
  name: string | null;
};

export type ForumPost = {
  id: string;
  title: string;
  content: string;
  createdAt: Date;
};

export type ForumComment = {
  id: string;
  content: string;
  createdAt: Date;
};

export type ForumCategory = {
  id: string;
  name: string;
};

export type GarminWorkout = {
  id: number;
  workoutName: string;
};

export type MapField = {
  id: string;
  polyline?: string;
  resourceState: number;
  summaryPolyline?: string;
};

export type GarminStrengthSet = {
  id: number;
  activityId: number;
  setIndex: number;
  setType: string | null;
  isRest: boolean | null;
  exerciseCategory: string | null;
  exerciseName: string | null;
  weightValue: number | null;
  weightDisplayUnit: string | null;
  repetitionValue: number | null;
  durationValue: number | null;
};

export type ActivityWithRelations = Activity & {
  laps?: StravaLap[];
  strengthSets?: GarminStrengthSet[];
};
export type WorkoutWithRelations = Workout & {
  analysis?: Analysis;
  garminWorkout?: GarminWorkout;
};
export type ForumPostWithRelations = ForumPost & {
  author: ForumUser & { user: User };
  comments: ForumCommentWithRelations[];
};
export type ForumCommentWithRelations = ForumComment & {
  author: ForumUser & { user: User };
};
export type ForumCategoryWithRelations = ForumCategory & {
  posts: ForumPostWithRelations[];
};

export type TrainingSettingInput = {
  maxHeartRate: number;
  restHeartRate: number;
  ftp: number;
  createdAt: Date;
  updatedAt: Date;
  sportsTypes: string[];
  sportsSpeeds: any;
  zoneCalcMethod: ZoneCalcMethod;
  unitSystem: UnitSystem;
  user: any;
};
